import { JSX } from 'react'

import { IconProps } from '../../icon'

const PlayVideo: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M38.3531 14.4399C37.9118 14.212 37.4154 14.1125 36.9204 14.1529C36.4254 14.1933 35.9517 14.372 35.5532 14.6685L30.8563 18.0969V17.7998C30.8563 16.5268 30.3506 15.306 29.4504 14.4058C28.5503 13.5057 27.3294 13 26.0564 13H12.7998C11.5268 13 10.306 13.5057 9.40583 14.4058C8.50569 15.306 8 16.5268 8 17.7998V31.0564C8 32.3294 8.50569 33.5503 9.40583 34.4504C10.306 35.3506 11.5268 35.8562 12.7998 35.8563H26.0564C27.2602 35.8636 28.4225 35.4172 29.312 34.6061C30.2015 33.795 30.7528 32.6786 30.8563 31.4793L35.8389 34.3477C36.246 34.5869 36.7096 34.7129 37.1817 34.7129C37.6539 34.7129 38.1174 34.5869 38.5245 34.3477C38.9892 34.0544 39.3694 33.6451 39.6279 33.1602C39.8864 32.6753 40.0142 32.1314 39.9987 31.5821V17.2741C40.0117 16.696 39.865 16.1256 39.5746 15.6255C39.2843 15.1255 38.8616 14.7152 38.3531 14.4399ZM28.5706 31.0564C28.5676 31.7223 28.3018 32.3601 27.8309 32.8309C27.3601 33.3018 26.7223 33.5676 26.0564 33.5706H12.7998C12.1339 33.5676 11.4962 33.3018 11.0253 32.8309C10.5545 32.3601 10.2886 31.7223 10.2856 31.0564V17.7998C10.2886 17.1339 10.5545 16.4962 11.0253 16.0253C11.4962 15.5545 12.1339 15.2886 12.7998 15.2856H26.0564C26.7223 15.2886 27.3601 15.5545 27.8309 16.0253C28.3018 16.4962 28.5676 17.1339 28.5706 17.7998V31.0564ZM37.7131 31.5821C37.7222 31.7347 37.6923 31.8872 37.6264 32.0251C37.5604 32.163 37.4605 32.2819 37.336 32.3707C37.276 32.4082 37.2067 32.4281 37.136 32.4281C37.0653 32.4281 36.996 32.4082 36.936 32.3707L30.8563 28.8622V20.8626L36.8903 16.5084C36.9533 16.4676 37.0267 16.4459 37.1017 16.4459C37.1768 16.4459 37.2502 16.4676 37.3131 16.5084C37.4452 16.5939 37.552 16.7131 37.6223 16.8538C37.6927 16.9945 37.724 17.1515 37.7131 17.3084V31.5821Z'
      fill='black'
    />
    <path
      d='M23.4851 23.4796L16.6282 18.9083C16.4596 18.7992 16.2651 18.7365 16.0645 18.7264C15.8639 18.7164 15.6641 18.7594 15.4854 18.8512C15.2987 18.9453 15.1413 19.0888 15.0305 19.2661C14.9197 19.4434 14.8596 19.6478 14.8569 19.8569V28.9994C14.8574 29.2061 14.914 29.4088 15.0207 29.5859C15.1274 29.763 15.2801 29.9079 15.4626 30.005C15.6413 30.0968 15.841 30.1398 16.0416 30.1298C16.2423 30.1198 16.4367 30.057 16.6054 29.9479L23.4623 25.3767C23.6178 25.2721 23.7453 25.1309 23.8334 24.9655C23.9215 24.8001 23.9676 24.6156 23.9676 24.4281C23.9676 24.2407 23.9215 24.0561 23.8334 23.8907C23.7453 23.7253 23.6178 23.5841 23.4623 23.4796H23.4851ZM17.1425 26.908V21.9939L20.7995 24.4281L17.1425 26.908Z'
      fill='black'
    />
  </svg>
)

export default PlayVideo
